var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { Item } from './item';
var ItemGroup = /** @class */ (function (_super) {
    __extends(ItemGroup, _super);
    function ItemGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "ItemGroup";
        _this.items = [];
        _this.modifier = false;
        _this.optional = false;
        _this.tags = [];
        _this.choices = 1;
        _this.repeat = false;
        _this.skippable = false;
        _this.cmap = {};
        _this.printers = [];
        return _this;
    }
    ItemGroup.prototype.getSelectedNames = function () {
        var names = [];
        for (var _i = 0, _a = this.selected; _i < _a.length; _i++) {
            var item = _a[_i];
            names.push(item.name);
        }
        return names.join();
    };
    ItemGroup.prototype.getSelectedItemIds = function () {
        var names = [];
        for (var _i = 0, _a = this.selected; _i < _a.length; _i++) {
            var item = _a[_i];
            names.push(item.id);
        }
        return names.join();
    };
    ItemGroup.prototype.toProperty = function (name, value) {
        switch (name) {
            case "items":
                value = Data.toDataArray(Item, value);
                break;
            default:
                value = _super.prototype.toProperty.call(this, name, value);
                break;
        }
        return value;
    };
    ItemGroup.getPublishedItems = function (ig, now) {
        return Item.filterPublished(ig.items, now);
    };
    ItemGroup.getPublishedItemsWithMap = function (catId, ig, index, filter) {
        var catId = catId;
        // catId = catId + "." + index.toString();
        return Item.filterPublishedItems(ig.items, ig.cmap, catId, index, filter);
    };
    ItemGroup.toItemGroupsData = function (itemGroups) {
        var results = [];
        for (var _i = 0, itemGroups_1 = itemGroups; _i < itemGroups_1.length; _i++) {
            var itemGroup = itemGroups_1[_i];
            var tmp = ItemGroup.toItemGroupData(itemGroup);
            results.push(tmp);
        }
        return results;
    };
    ItemGroup.toItemGroupData = function (itemGroup) {
        var json = {};
        json["id"] = itemGroup.id;
        json["items"] = Item.toItemsData(itemGroup.items);
        json["name"] = itemGroup.name;
        json["pagerMode"] = itemGroup.pagerMode;
        return json;
    };
    return ItemGroup;
}(Data));
export { ItemGroup };
//# sourceMappingURL=item-group.js.map